
import { Vue, Component } from 'vue-property-decorator'
import ProjectWebsite from '@/types/projectWebsite'
import ProjectWebsiteEditDetailsTab from '@/views/projectwebsite/tabs/ProjectWebsiteEditDetailsTab.vue'
import ProjectWebsiteEditRelationsTab from '@/views/projectwebsite/tabs/ProjectWebsiteEditRelationsTab.vue'
import ProjectWebsiteEditPagesTab from '@/views/projectwebsite/tabs/ProjectWebsiteEditPagesTab.vue'
import ProjectWebsiteEditPartnersTab from '@/views/projectwebsite/tabs/ProjectWebsiteEditPartnersTab.vue'
import ProjectWebsiteEditNewsTab from '@/views/projectwebsite/tabs/ProjectWebsiteEditNewsTab.vue'
import ls from '@/ls'

@Component({
  components: { ProjectWebsiteEditNewsTab, ProjectWebsiteEditPartnersTab, ProjectWebsiteEditPagesTab, ProjectWebsiteEditRelationsTab, ProjectWebsiteEditDetailsTab }
})

export default class ProjectWebsiteEdit extends Vue {
  settings = {
    routeNames: { list: 'projectWebsites', show: 'projectWebsiteShow', edit: 'projectWebsiteEdit' },
    routeParamKey: 'projectWebsiteId',
    functionNames: { setCurrent: 'setCurrentProjectWebsite', clearCurrent: 'clearCurrentProjectWebsite', save: 'saveProjectWebsite' },
    getterNames: { current: 'currentProjectWebsite', loading: 'loadingProjectWebsite' }
  }

  currentTab:string = ls.get('projectWebsiteEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('projectWebsiteEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, paramKey:string|undefined, id:number|undefined) : void {
    if (id && paramKey) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : ProjectWebsite {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
